import { render } from "./ArtistsList.vue?vue&type=template&id=88abe630&scoped=true"
import script from "./ArtistsList.vue?vue&type=script&lang=js"
export * from "./ArtistsList.vue?vue&type=script&lang=js"

import "./artists.scss?vue&type=style&index=0&id=88abe630&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88abe630"]])

export default __exports__